

const SET_LTCAT = (state,ltcat) => {
	state.data = ltcat

	var title = '';

	if (ltcat && ltcat.empresa) {
		title += ltcat.empresa.nome;
	}

	if(ltcat.revisao) {
		title += ' :: ';

		if (ltcat.revisao.parent) {
			title += ltcat.revisao.parent.rev + ' (' + ltcat.revisao.parent.descricao + ') / '
		}
		title += ltcat.revisao.rev + ' (' + ltcat.revisao.descricao + ')'
	}

	if (title) {
		title += ' :: ';
	}

	state.title = title;
}

export{
	SET_LTCAT
}



// WEBPACK FOOTER //
// ./src/store/ltcat/mutations.js